module.exports = __webpack_public_path__ + "img/culcheck.9f40dff2.jpg";